import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import saveByteArray from "src/util/saveByteArray";
import { IDocument } from "../interfaces/IDocument";
import { FilesCategoryEnum, FilesCategoryEnumLabel } from "../Enum/FilesCategoryEnum";
import { DocumentCategoryEnum } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';
import { ITrade } from '../interfaces/trade/ITrade';
import { generateQueryString } from 'src/util/helper';

enum DocumentServiceEnum {
  proxyDownload = "/proxy-download",
  downloadTradeContractByTradeId = "/download-contract/",
  downloadTradeDocumentByDocumentPath = "/",
  putGenericDocument = "/upload-generic-document",
  deleteByFileId = "?fileId=",
  downloadOfficerLogo = "/",
  getLegalCertificatesByTradeId = "/find-legal-certificates?tradeId=",
  getMarriageCertificateByTradeId = "/find-marriage-certificate?tradeId=",
  getDocumentByTradeAndCategory = "/get-document-by-category",
  getOfficerCessionContractByTradeId = "/contrato-cessao-officer/",
  getOfficerAcceptenceContractByTradeId = "/contrato-aceite-officer/",
  getInvoiceByTradeId = "/find-invoice?tradeId=",
  getSpouseDocIdByTradeId = "/get-spouse-doc-id?tradeId=",
  getDocumentCategory="/document-category",

  downloadPaperclipDocument = "/download-paperclip-document/",
  downloadContractWithAttorneys = "/download-with-attorneys/",
  downloadSpecialProjectDocument = "/download-special-project-document/",

  downloadTradeDocument = "/",
  uploadGeneric = "/upload",
  ted= "/ted"

}
export default class DocumentService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/document");
  }

  public downloadContractByTradeId = async tradeId => {
    const data = await this.GET(DocumentServiceEnum.downloadTradeContractByTradeId + tradeId, "blob");
    saveByteArray("Contrato.zip", data);
    return data;
  };

  public downloadDocumentByPath = async (document: IDocument) => {
    const data = await this.GET(DocumentServiceEnum.downloadTradeDocumentByDocumentPath + document.path, "blob");
    saveByteArray(document.fileName, data);
    return data;
  };

  public proxyDownload = async (uri: string, filename: string) => {
    const data = await this.POST(DocumentServiceEnum.proxyDownload, { uri }, "blob");
    saveByteArray(filename, data);
    return data;
  }

  public putGenericDocument = async file => await this.PUT(DocumentServiceEnum.putGenericDocument, file);
  public deleteByFileId = async fileId => await this.DELETE(DocumentServiceEnum.deleteByFileId + fileId);
  public downloadOfficerLogo = async logoFileKey => await this.GET(DocumentServiceEnum.downloadOfficerLogo + logoFileKey, "blob");
  public getLegalCertificatesByTradeId = async (tradeId: number): Promise<IDocument[]> => await this.GET(DocumentServiceEnum.getLegalCertificatesByTradeId + tradeId);
  public getMarriageCertificateByTradeId = async (tradeId: number) => await this.GET(DocumentServiceEnum.getMarriageCertificateByTradeId + tradeId);
  public getDocumentByTradeAndCategory = async (tradeId: number, category: DocumentCategoryEnum) => await this.GET(`${DocumentServiceEnum.getDocumentByTradeAndCategory}/${tradeId}/${category}`);
  public getOfficerCessionContractByTradeId = async (tradeId: number) => await this.GET(DocumentServiceEnum.getOfficerCessionContractByTradeId + tradeId, "blob");
  public getOfficerAcceptenceContractByTradeId = async (tradeId: number) => await this.GET(DocumentServiceEnum.getOfficerAcceptenceContractByTradeId + tradeId, "blob");
  public getInvoiceByTradeId = async (tradeId: number): Promise<IDocument> => await this.GET(DocumentServiceEnum.getInvoiceByTradeId + tradeId);
  public getSpouseDocIdByTradeId = async (tradeId: number): Promise<any> => await this.GET(DocumentServiceEnum.getSpouseDocIdByTradeId + tradeId);
  public getDocumentCategory = async(): Promise<DocumentCategoryEnum[]> => await this.GET(DocumentServiceEnum.getDocumentCategory);

  public downloadPaperclipDocument = async (documentType: FilesCategoryEnum, tradeId?: number, user?: string) => {
    const filename = `${tradeId ? `${tradeId}_` : ""}${FilesCategoryEnumLabel.get(documentType)}${user ? `_${user}` : ""}.docx`;
    const endpoint = `${DocumentServiceEnum.downloadPaperclipDocument}${tradeId}/${FilesCategoryEnum[documentType]}`;
    const data = await this.GET(endpoint, "blob");

    saveByteArray(filename, data);
    return data;
  };

  //#region  novos pós refatoração
  public downloadDocument = async (document: IDocument, tradeId?: number, user?: string) => {
    const filename = (tradeId ? `${tradeId}_` : "") + document.fileName ? document.fileName : "documento" + (user ? `_${user}` : "") + ".docx";
    const data = await this.GET(DocumentServiceEnum.downloadTradeDocument + (document.file && document.file !== "null" ? document.file : document.path), "blob");
    saveByteArray(filename, data);
    return data;
  };

  public putUploadGeneric = async data => await this.PUT(DocumentServiceEnum.uploadGeneric, data);

  public downloadSpecialProjectDocument = async (idTrade?: number, user?: string) => {
    const endpoint = DocumentServiceEnum.downloadSpecialProjectDocument + idTrade;
    const data = await this.GET(endpoint, "blob");
    const filename = (idTrade ? `${idTrade}_` : "") + (user ? `_${user}` : "") + ".zip";
    saveByteArray(filename, data);
    return data;
  };
  public ted = async ({ id, tradePricing: { pricing: { pricingDisbursements } } }: ITrade, fileKey: string) => {
    const filename = (id ? `${id}_` : "") + pricingDisbursements.find(f => f.tedDocumentKey === fileKey)?.trigger + "TED.pdf";
    const data = await this.GET(`${DocumentServiceEnum.ted}?${generateQueryString({ tradeId: id, fileKey })}`, "blob");

    saveByteArray(filename, data);
    return data;
  };

  //#endregion
}



// WEBPACK FOOTER //
// ./src/services/api/Document.service.ts